import { types } from './constants';

export const changeCalendarDay = (selectedDay) => ({
  type: types.SELECTED_DAY_CHANGED,
  selectedDay
});

export const fetchBroadcastContentEPGData = (contentID, epgID, from, to) => ({
  type: types.EPG_DATA_FETCH,
  contentID,
  epgID,
  from,
  to
});

export const loadEPGDataFetchFailure = (errors) => ({
  type: types.EPG_DATA_FETCH_FAILURE,
  errors
});

export const loadEPGDataFetchSuccess = (epgDataItems) => ({
  type: types.EPG_DATA_FETCH_SUCCESS,
  epgDataItems
});